/** @format */

import React, { useState, useEffect, useRef } from "react";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.js";
import "bootstrap-icons/font/bootstrap-icons.css";
import "../../css/ReportMobile.css";

import { Modal } from "bootstrap";

import * as funcAll from "../../util/funcAll";

/////////////   Redux  //////////////
import { saveDataLatLon } from "../store/MapPositionSlice";
import { useSelector, useDispatch } from "react-redux";
import SecureStorage from "react-secure-storage";

import Follow_up_TH from "../menu/Follow-up-newTH";

const constants = require("file-configs/constants");

export default function FollowMobileTHNew(props) {
  const globalData = useSelector((state) => ({ ...state }));
  const dispatch = useDispatch();

  const [success, setSuccess] = useState(false);
  const [error_message_password, setErrorMessagePassword] = useState("");

  const [ticket_id, setTicketId] = useState("");
  const [password, setPassword] = useState("");
  const authorizeCase = JSON.parse(sessionStorage.getItem("authorization"));
  const detailReport2 = sessionStorage.getItem("detailReport2");
  const [hasChecked, setHasChecked] = useState(false);

  useEffect(() => {
    if (detailReport2) {
      setSuccess(true);
    } else {
    }
  }, [detailReport2]);

  useEffect(() => {
    if (authorizeCase && !hasChecked) {
      setHasChecked(true);

      showLoadingAnimation();
      // setTicketId(authorizeCase["ticket_report"]);
      // setPassword(authorizeCase["password_report"]);

      funcAll
        .checkCasePassword(
          authorizeCase["ticket_report"],
          authorizeCase["password_report"],
          "th"
        )
        .then((res) => {
          if (res["status"] === "success") {
            SecureStorage.setItem("detailReport", res["results"]);
            sessionStorage.setItem(
              "detailReport2",
              JSON.stringify(res["results"])
            );
            setErrorMessagePassword("");
            hideLoadingAnimation();
            props.reloadNav(authorizeCase["ticket_report"]);
            setTimeout(() => {
              setSuccess(true);
            }, 500);
          } else {
            SecureStorage.setItem("detailReport", []);
            setErrorMessagePassword(
              "* Wrong Ticket ID or password. Please check and enter again."
            );
            hideLoadingAnimation();
            setTimeout(() => {
              setSuccess(false);
            }, 500);
          }
        });
    }
  }, [authorizeCase]);

  const handleCheckPassword = () => {
    showLoadingAnimation();

    funcAll.checkCasePassword(ticket_id, password, "th").then((res) => {
      if (res["status"] === "success") {
        // SecureStorage.setItem("detailReport", res["results"]);
        sessionStorage.setItem("detailReport2", JSON.stringify(res["results"]));
        setErrorMessagePassword("");
        hideLoadingAnimation();
        props.reloadNav(authorizeCase["ticket_report"]);
        setTimeout(() => {
          setSuccess(true);
        }, 500);
      } else {
        hideLoadingAnimation();
        setTimeout(() => {
          setSuccess(false);
        }, 500);
        SecureStorage.setItem("detailReport", []);
        setErrorMessagePassword(
          "* Ticket ID หรือ รหัสผ่านไม่ถูกต้อง กรุณาตรวจสอบอีกครั้ง"
        );
      }
    });
  };

  const sendReportData = async (e) => {
    e.preventDefault();
  };

  function showLoadingAnimation() {
    document.getElementById("loading-container").style.display = "flex";
  }

  // Hide the loading animation
  function hideLoadingAnimation() {
    document.getElementById("loading-container").style.display = "none";
  }

  return (
    <>
      {detailReport2 ? (
        <>
          <Follow_up_TH />
          <div
            className="loading-container"
            id="loading-container"
            style={{ height: "1rem" }}></div>
        </>
      ) : (
        <div className="container-in-tab-content">
          {authorizeCase ? (
            <div>
              <div className="loading-container" id="loading-container">
                <div className="loader" />
                <p>Waiting...</p>
              </div>
            </div>
          ) : (
            <form
              id="myform"
              class="needs-validation"
              novalidate
              onSubmit={sendReportData}>
              <div className="container-title pt-2">
                <p className="txt-th title">Ticket ID</p>
              </div>

              <input
                required
                type="text"
                className="form-control shadow-style input"
                value={ticket_id}
                onChange={(e) => setTicketId(e.target.value)}
              />

              <div className="container-title pt-3">
                <p className="txt-th title">Pin</p>
              </div>

              <input
                required
                type="text"
                className="form-control shadow-style input"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <div className="mt-3">
                <p className="err-message-txt">{error_message_password}</p>
              </div>

              <a
                className="btn-report my-5"
                onClick={() => handleCheckPassword()}>
                <p>ติดตามความคืบหน้า</p>
              </a>

              <div className="loading-container" id="loading-container">
                {/* <div className="loader" />
                <p>Waiting...</p> */}
              </div>
            </form>
          )}
        </div>
      )}
    </>
  );
}
